import StatisticSection from '../../../components/statistics-section';
import StatisticsSectionBarChartType from '../../../components/statistics-section.bar-chart-type';
import StatisticsSectionChartType from '../../../components/statistics-section.chart-type';
import { useEffect, useState } from 'react';
import { apiService } from '../../../services/api.service';
import { StatisticLineChartData, StatusType } from '../../../types/statistics.types';
import { useNavigate } from 'react-router-dom';
import DashboardPagePartSummary from './dashboard-page.part.summary';
import { useSelector } from 'react-redux';
import { UserState } from '../../../store/user.slice';
import { AppStore } from '../../../store/store';
import { ReactComponent as UserIcon } from '../../../assets/icons/user.svg';
import { ReactComponent as MerchantIcon } from '../../../assets/icons/merchant.svg';
import { ReactComponent as CardIcon } from '../../../assets/icons/processor-card.svg';
import TableContent from '../../../components/table-content';
import dateService from '../../../services/date.service';
import { colorsPalette } from '../../../utils/colors-utils';
import { TransactionSummary } from '../../../types/transaction.types';
import { formatAmount } from '../../../utils/number-utils';
import { getColorByCardBrandType, getColorByStatusType, transformCardBrandToChartLineData, transformToChartLineData, transformTransactionsToChartLineData } from '../../../utils/constants';
import StatisticsSectionLineChart from '../../../components/statistics-section.line-chart';
import { mockChartData } from '../../../mock/merchants.statistics';
import './dashboard-page.scss';


// const mockData = [
//     {
//         label: 'ERROR',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 50) + 25,
//         })),
//     },
//     {
//         label: 'DECLINED',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 30) + 30,
//         })),
//     },
//     {
//         label: 'REFUNDED',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 10) + 15,
//         })),
//     },

//     {
//         label: 'APPROVED',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 20) + 40,
//         })),
//     },
//     {
//         label: 'CHARGEBACK',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 30) + 35,
//         })),
//     },
//     {
//         label: 'PENDING',
//         data: Array.from({ length: 24 }, (_, h) => ({
//             label: `${h.toString().padStart(2, '0')}:00`,
//             value: Math.floor(Math.random() * 10) + 5,
//         })),
//     },

// ];

// const transformToChartLineData = (
//     datasets: { label: string; data: { label: string; value: number }[] }[]
// ) => {
//     return datasets.map(ds => ({
//         label: ds.label,
//         values: ds.data,
//         colors: getGradientColorsByStatus(ds.label as StatusType),
//     }));
// };



// const chartLineData = transformToChartLineData(mockData);

const DashboardPage = () => {

    const navigate = useNavigate();

    const { user } = useSelector<AppStore, UserState>((state) => state.user);

    const isMerchant = (user?.roles?.includes("merchant") || user?.roles?.includes("bas_merchant_view")) ?? false;


    const [transactionsSummary, setTransactionsSummary] = useState<TransactionSummary>();
    const [summaryLoader, setSummaryLoader] = useState(false);

    const [transactionsStatus, setTransactionsStatus] = useState();
    const [statusLoader, setStatusLoader] = useState(false);
    const [transactionsChartStatus, setTransactionsChartStatus] = useState<StatisticLineChartData[]>();
    const [transactionsChartLoader, setTransactionsChartLoader] = useState(false);

    const [cardTypes, setCardTypes] = useState([]);
    const [cardsLoader, setCardsLoader] = useState(false);
    const [cardChartTypes, setCardChartTypes] = useState<StatisticLineChartData[]>();
    const [cardChartLoader, setCardChartLoader] = useState(false);

    const [processors, setProcessors] = useState();
    const [processorsLoader, setProcessorsLoader] = useState(false);
    const [processorsChart, setProcessorsChart] = useState<StatisticLineChartData[]>();
    const [processorsChartLoader, setProcessorsChartLoader] = useState(false);

    const [merchants, setMerchants] = useState();
    const [merchantsLoader, setMerchantsLoader] = useState(false);
    const [merchantsChart, setMerchantsChart] = useState<StatisticLineChartData[]>();
    const [merchantsChartLoader, setMerchantsChartLoader] = useState(false);


    const [recentTransactions, setRecentTranscations] = useState();
    const [recentLoader, setRecentLoader] = useState(false);


    useEffect(() => {

        setStatusLoader(true)
        apiService.getTransactionsStatusStatistics({})
            .then((response) => {
                const transformedData = response.data.map((item: any, index: number) => ({
                    color: getColorByStatusType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setTransactionsStatus(transformedData);
            })
            .catch((error) => console.error('Error fetching transactions status:', error))
            .finally(() => setStatusLoader(false))

        setTransactionsChartLoader(true)
        apiService.getChartTransactionsData()
            .then((response) => {
                const transactionChartData: StatisticLineChartData[] = transformTransactionsToChartLineData(response.data);
                setTransactionsChartStatus(transactionChartData);
            })
            .catch((error) => console.error('Error fetching transactions chart status:', error))
            .finally(() => setTransactionsChartLoader(false))

        setCardsLoader(true)
        apiService.getCardTypeStatistics({})
            .then((response) => {
                const transformedData = response.data.map((item: any) => ({
                    color: getColorByCardBrandType(item.name),
                    name: item.name,
                    quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                    quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                    qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                    qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                }));
                setCardTypes(transformedData);
            })
            .catch((error) => console.error('Error fetching card types:', error))
            .finally(() => setCardsLoader(false))

        setCardChartLoader(true)
        apiService.getChartCardData()
            .then((response) => {
                const cardsChartData: StatisticLineChartData[] = transformCardBrandToChartLineData(response.data);
                setCardChartTypes(cardsChartData);
            })
            .catch((error) => console.error('Error fetching card chart data:', error))
            .finally(() => setCardChartLoader(false))

        setProcessorsLoader(true)
        apiService.getProcessorStatistics({})
            .then((response) => {
                const transformedData = response.data.map((item: any, index: number) => {
                    return ({
                        color: colorsPalette[index],
                        name: item.name,
                        type: isMerchant ? null : item.type,
                        quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                        quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                        qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                        qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                    })
                });
                setProcessors(transformedData);
            })
            .catch((error) => console.error('Error fetching processors:', error))
            .finally(() => setProcessorsLoader(false))

        setProcessorsChartLoader(true)
        apiService.getChartProcessorData()
            .then((response) => {
                const processorChartData: StatisticLineChartData[] = transformToChartLineData(response.data);
                setProcessorsChart(processorChartData);
            })
            .catch((error) => console.error('Error fetching processor chart data:', error))
            .finally(() => setProcessorsChartLoader(false))


        if (!isMerchant && user) {
            setMerchantsLoader(true)
            apiService.getMerchantStatistics({})
                .then((response) => {
                    const transformedData = response.data.map((item: any, index: number) => ({
                        id: item.id,
                        color: colorsPalette[index],
                        name: item.name,
                        quantitativePercent: item.quantityAndQuality?.quantitativePercent || 0,
                        quantitativeValue: item.quantityAndQuality?.quantitativeValue || 0,
                        qualitativePercent: item.quantityAndQuality?.qualitativePercent || 0,
                        qualitativeValue: item.quantityAndQuality?.qualitativeValue || 0,
                    }));
                    setMerchants(transformedData);
                })
                .catch((error) => console.error('Error fetching merchants:', error))
                .finally(() => setMerchantsLoader(false))

            setMerchantsChartLoader(true)
            apiService.getChartMerchantData()
                .then((response) => {
                    const merchantsChartData: StatisticLineChartData[] = transformToChartLineData(response.data);
                    setMerchantsChart(merchantsChartData);
                })
                .catch((error) => console.error('Error fetching merchant chart data:', error))
                .finally(() => setMerchantsChartLoader(false))
        }

        setSummaryLoader(true)
        apiService.getTransactionsSummaryToday()
            .then((response) => {
                setTransactionsSummary(response.data);
            })
            .catch((error) => console.error('Error fetching transactions summary:', error))
            .finally(() => setSummaryLoader(false))

        setRecentLoader(true)
        apiService.getRecentTransactions()
            .then((response) => {
                setRecentTranscations(response.data);
            })
            .catch((error) => console.error('Error fetching transactions summary:', error))
            .finally(() => setRecentLoader(false))

    }, [user]);

    const columnsRecentTransactions = [
        {
            Header: 'Trace ID',
            accessor: 'id',
            Cell: ({ value, row }: { value: string, row: any }) => (
                <div>
                    <span
                        className="id-text"
                        onClick={() => navigate(`/app/transactions/transaction/${row.original.id}`)}
                    >{value}</span>
                </div>
            ),
        },
        {
            Header: 'Customer',
            accessor: 'customerName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <UserIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">
                        {row.original.customerCardType} xxxx xxxx xxxx {row.original.customerLastFourCardDigits}
                    </div>
                </div>
            ),
        },
        {
            Header: 'Merchant',
            accessor: 'merchantName',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div className="flex-column flex-gap-5">
                    <div className="flex-row flex-gap-5 flex-align-start-center">
                        <MerchantIcon />
                        <span>{value}</span>
                    </div>
                    <div className="secondary-text accent-gradient-text">{row.original.transactionReferenceCode}</div>
                </div>
            ),
        },
        {
            Header: 'Channel',
            accessor: 'processorName',
            Cell: ({ value, row }: { value: string; row: any }) => {

                return (
                    <div className="flex-column flex-gap-5">
                        <div className="flex-row flex-gap-5 flex-align-start-center">
                            <CardIcon />
                            <span>{isMerchant ? row.original.processorType : value}</span>
                        </div>
                        <div className="secondary-text accent-gradient-text">{!isMerchant && row.original.processorTransactionId}</div>
                    </div>
                )
            },
        },
        {
            Header: 'Value',
            accessor: 'amount',
            Cell: ({ value }: { value: string }) => (
                <span className="value-text accent-gradient-text">${formatAmount(+value)}</span>
            ),
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center' style={{ textAlign: 'center' }} >
                    Status
                </div>
            ),
            accessor: 'status',
            Cell: ({ value, row }: { value: string; row: any }) => (
                <div
                    className={`status ${value?.toLowerCase()}
                 flex-row flex-align-center-center`}
                    onClick={() => navigate(`/app/transactions/transaction/${row.original.id}`)}
                >
                    <span>{value}</span>
                </div>
            ),
        },
        {
            Header: () => (
                <div className='flex-row flex-align-center-center'>
                    Time
                </div>
            ),
            accessor: 'date',
            Cell: ({ value }: { value: string }) => (
                <div className="date-text">{dateService.formatDateForTable(value)}</div>
            ),
        },

    ];

    const handleMerchantNavigate = (id: string) => {
        navigate(`/app/merchants/merchant/${id}`);
    }


    return (
        <div className='dashboard-page page-content'>
            <div className='flex-row flex-align-space-between-start width-100 flex-wrap'>
                <div className='page-title'>
                    Dashboard
                </div>
                <DashboardPagePartSummary transactionsNo={transactionsSummary?.transactionCount || 0} amount={transactionsSummary?.totalAmount || 0} commission={9000} isLoading={summaryLoader} />
            </div>
            <StatisticSection title='Status Statistics'>
                <StatisticsSectionChartType data={transactionsStatus || []} isLoading={statusLoader} />
                <StatisticsSectionLineChart data={transactionsChartStatus || []} isLoading={transactionsChartLoader} />
            </StatisticSection>
            {cardTypes.length > 0 &&
                <StatisticSection title='Card Brand Statistics'>
                    <StatisticsSectionChartType data={cardTypes || []} isLoading={cardsLoader} />
                    <StatisticsSectionLineChart data={cardChartTypes || []} isLoading={cardChartLoader} />
                </StatisticSection>
            }

            <StatisticSection title='Processors Statistics'>
                <StatisticsSectionBarChartType data={processors || []} isLoading={processorsLoader} />
                <StatisticsSectionLineChart data={processorsChart || []} isLoading={processorsChartLoader} />
            </StatisticSection>
            {!isMerchant &&
                <StatisticSection title='Merchants Statistics'>
                    <StatisticsSectionBarChartType data={merchants || []} onNavigate={handleMerchantNavigate} isLoading={merchantsLoader} />
                    <StatisticsSectionLineChart data={merchantsChart || []} isLoading={merchantsChartLoader} />
                </StatisticSection>
            }
            <div className='inner-page flex-column flex-gap-20 width-100'>
                <StatisticSection title='Recent Transactions'>
                    <TableContent columns={columnsRecentTransactions} data={recentTransactions || []} isLoading={recentLoader}></TableContent>
                </StatisticSection>
            </div>
        </div>
    )
}
export default DashboardPage; 